export enum CalibrationUnit {
  FeetPerMinute = 'feet per minute',
  PSI = 'PSI',
}
